/* Dolce Vita Supplements — global motion helpers
   - splits [data-split-words] into per-word spans for staggered reveal
   - assigns --i index to children of [data-reveal-stagger]
   - all reveals tied to IntersectionObserver, single observer
   - respects prefers-reduced-motion
*/
(function () {
  if (window.__dvMotion) return;
  window.__dvMotion = true;

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- split headlines into words
  document.querySelectorAll('[data-split-words]').forEach((el) => {
    if (el.dataset.split === 'done') return;
    el.dataset.split = 'done';
    const text = el.textContent.trim();
    el.textContent = '';
    const words = text.split(/(\s+)/);
    let i = 0;
    for (const part of words) {
      if (/^\s+$/.test(part)) {
        const sp = document.createElement('span');
        sp.className = 'dv-word dv-word--space';
        sp.innerHTML = '&nbsp;';
        el.appendChild(sp);
      } else if (part.length) {
        const sp = document.createElement('span');
        sp.className = 'dv-word';
        sp.style.setProperty('--i', i++);
        sp.textContent = part;
        el.appendChild(sp);
      }
    }
  });

  // ---- wrap last word of [data-squiggle-last] elements in .dv-squiggle (applied AFTER word split)
  document.querySelectorAll('[data-squiggle-last]').forEach((el) => {
    const words = el.querySelectorAll('.dv-word:not(.dv-word--space)');
    if (words.length) words[words.length - 1].classList.add('dv-squiggle');
  });

  // ---- assign --i to stagger children
  document.querySelectorAll('.dv-reveal-stagger').forEach((el) => {
    Array.from(el.children).forEach((child, idx) => {
      if (!child.style.getPropertyValue('--i')) child.style.setProperty('--i', idx);
    });
  });

  // ---- single IntersectionObserver for reveal classes
  const targets = document.querySelectorAll('.dv-reveal, .dv-reveal-stagger, [data-split-words]');
  if (!('IntersectionObserver' in window) || reduce) {
    targets.forEach((el) => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
  );
  targets.forEach((el) => io.observe(el));

  // ---- cart count bubble bounces when cart updates (intercept Dawn's fetch calls)
  const origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (...args) {
      const url = (args[0] && args[0].url) || args[0] || '';
      const result = origFetch.apply(this, args);
      if (typeof url === 'string' && /\/cart\/(add|change|update)/i.test(url)) {
        result
          .then(() => {
            requestAnimationFrame(() => {
              document.querySelectorAll('[data-cart-count]').forEach((el) => {
                el.classList.remove('is-bumped');
                void el.offsetWidth;
                el.classList.add('is-bumped');
              });
            });
          })
          .catch(() => {});
      }
      return result;
    };
  }
})();
